import {
  FormHelperText,
  InputLabel,
  OutlinedInput,
  IconButton,
  Stack,
  InputAdornment,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import RequirePoint from "@/components/RequirePoint";

const ZkInput = (props) => {
  const {
    formik = null,
    placeholder = "",
    handleBlur,
    handleChange,
    label,
    name,
    error,
    disabled = false,
    isClear = true,
    labelPostion,
    spacing = 1,
    width,
    height,
    inputType,
    inputRef,
    fontSize = "16px",
    onKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    },
    ...orther
  } = props;

  const blurFn = (e) => {
    if (formik?.handleBlur) {
      formik?.handleBlur(e);
    }
    if (handleChange) {
      handleChange();
    }
  };

  const changeFn = (e) => {
    if (formik?.handleChange) {
      formik?.handleChange(e);
    }
    if (handleBlur) {
      handleBlur(e);
    }
    if (handleChange) {
      handleChange(e);
    }
  };

  return (
    <Stack spacing={1}>
      <Stack
        direction={labelPostion === "left" ? "row" : "column"}
        sx={{
          alignItems: labelPostion === "left" ? "flex-start" : "",
        }}
        spacing={1}>
        {label && (
          <InputLabel
            style={{
              marginTop: labelPostion === "left" ? "12px" : "",
              width: width,
              fontSize: fontSize,
            }}
            htmlFor={"ZkInput_" + name}>
            {props.required && <RequirePoint></RequirePoint>} {label}
          </InputLabel>
        )}
        <Stack
          sx={{
            flexGrow: 1,
            width: "100%",
          }}>
          <OutlinedInput
            id={"ZkInput_" + name}
            type={"text"}
            autoComplete={"off"}
            value={formik?.values[name]}
            name={name}
            onBlur={blurFn}
            onChange={changeFn}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            fullWidth
            error={Boolean(
              (formik?.touched[name] && formik?.errors[name]) || error
            )}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  id="clearButton"
                  onClick={() => formik.setFieldValue(name, "")}
                  style={{
                    visibility: formik.values[name] ? "visible" : "hidden",
                  }}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            }
            disabled={disabled}
            sx={{
              "& .MuiInputLabel-root": {
                color: "#D1D1D1",
                cursor: "pointer",
              },

              height: 50,
              width: "250px",
              background: "#fff",
              color: "#474B4F",
              opacity: "0.6",
              boxShadow: "0px 1px 3px #0000001A",
              borderRadius: "8px",
              border: "0px !important",
              cursor: "pointer",
            }}
            {...orther}
          />
          {((formik?.touched[name] && formik?.errors[name]) || error) && (
            <FormHelperText error id={`standard-weight-helper-text-${name}`}>
              {formik?.errors[name] || error}
            </FormHelperText>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ZkInput;
